import { render, staticRenderFns } from "./TabSummary.vue?vue&type=template&id=8bee7d6a&scoped=true&"
import script from "./TabSummary.vue?vue&type=script&lang=js&"
export * from "./TabSummary.vue?vue&type=script&lang=js&"
import style0 from "./TabSummary.vue?vue&type=style&index=0&id=8bee7d6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bee7d6a",
  null
  
)

export default component.exports